import API_URLS from '../config/apiConfig';
import { apiGet } from '../utils/apiUtils';
import type { LotteryPackSnapshotResponse } from '../types/services/lotteryPacks';

class BackstockSimulatorService {
  async getLotteryPacks(storeId: string): Promise<LotteryPackSnapshotResponse> {
    return apiGet(API_URLS.GET_LOTTERY_PACKS(storeId));
  }
}

const backstockSimulatorService = new BackstockSimulatorService();

export default backstockSimulatorService;
